import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import StatusBarWide from '../../components/Projects/StatusBarWide';
import { DSButton } from '../../components/Button/Button';
import { PROJECT_STATUS } from '../../interfaces/project';
import { ApplicationInterface } from '../../interfaces/application';

type PropsType = {
  project: ApplicationInterface;
  buttonText: string;
  buttonDisabled: boolean;
};

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '40px',
    marginBottom: '40px',
  },
});

const StatusBarRow: React.FC<PropsType> = ({ project, buttonText, buttonDisabled }) => {
  const classes = useStyles();

  return (
    <div className={classes.row}>
      <StatusBarWide status={project.setup?.status || PROJECT_STATUS.DRAFT} />
      <DSButton className={buttonDisabled ? 'disabled' : ''} type="submit">
        {buttonText}
      </DSButton>
    </div>
  );
};

export default StatusBarRow;
